module.exports = __webpack_public_path__ + "static/media/cert4.ca0cac78.jpeg";